import chatAssistantNewQuestion from "./chatAssistantNewQuestion.api";
import getChatAssistantHistory from "./getChatAssistantHistory.api";
import getChatAssistantQuestion from "./getChatAssistantQuestion.api";

const chatAssistantApi = {
  chatAssistantNewQuestion,
  getChatAssistantHistory,
  getChatAssistantQuestion,
};

export default chatAssistantApi;
